import http from "./http.service";
import Promisable from "./promisable.service";
import { getAppDispatch } from "utils/dispatch.util";
import { timeZoneActions } from "redux/slices/timeZone";
import ToasterService from "utils/toaster.util";

const url = "/zone/timezone";

const timeZoneService = {
  getTimeZone: async (lat: Number, lng: Number) => {
    const dispatch = getAppDispatch();

    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.get(`${url}?lat=${lat}&lng=${lng}`, { silentToast: true } as any)
    );

    if (error) {
      dispatch?.(timeZoneActions.setLoading(false));
      return [null, error];
    }

    const { timezone, message } = success.data.data || {};
    const { timeZoneName, timeZoneId } = timezone || {};

    if (!timeZoneId) {
      ToasterService.showError(message || "Unable to resolve timezone");
      dispatch?.(timeZoneActions.setLoading(false));
      return [null, new Error(message || "Unable to resolve timezone")];
    }

    dispatch?.(timeZoneActions.setTimeZone({ timeZoneName, timeZoneId }));
    dispatch?.(timeZoneActions.setLoading(false));
    return [success, null];
  },
};

export default timeZoneService;
